"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Favicon = _react2.default.createElement(
  _react2.default.Fragment,
  null,
  _react2.default.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "180x180",
    href: "https://static.olx.com.br/cd/vi/images/icons/apple-touch-icon.png"
  }),
  _react2.default.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "32x32",
    href: "https://static.olx.com.br/cd/vi/images/icons/favicon-32x32.png"
  }),
  _react2.default.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "192x192",
    href: "https://static.olx.com.br/cd/vi/images/icons/android-chrome-192x192.png"
  }),
  _react2.default.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "16x16",
    href: "https://static.olx.com.br/cd/vi/images/icons/favicon-16x16.png"
  }),
  _react2.default.createElement("link", {
    rel: "manifest",
    href: "https://static.olx.com.br/cd/vi/images/icons/site.webmanifest"
  }),
  _react2.default.createElement("link", {
    rel: "mask-icon",
    href: "https://static.olx.com.br/cd/vi/images/icons/safari-pinned-tab.svg",
    color: "#6e0ad6"
  })
);

exports.default = Favicon;